module.exports = __webpack_public_path__ + "img/groceries-benchmark.e82c10d7.svg";